/* Prozone B2B — pz-qr.js
   QR-facture suisse (Swiss QR Code, Swiss Payment Standards v2.0) rendu en SVG,
   entierement cote navigateur.

   Pourquoi un encodeur maison plutot qu'une bibliotheque ou un service :
   la charge utile contient l'IBAN, le montant et la reference du client. Elle
   ne doit sortir ni vers un CDN ni vers un generateur d'images tiers. Tout est
   calcule ici, hors ligne.

   Contraintes du standard appliquees :
   - correction d'erreur M (imposee par les Swiss Implementation Guidelines) ;
   - croix suisse de 7 mm au centre d'un code de 45.8 mm, soit un rapport fixe,
     geometrie reprise de l'implementation de reference claudep/swiss-qr-bill ;
   - charge utile de 31 lignes separees par LF, en-tete SPC, pied EPD.

   API : PZQR.payload(o) -> string, PZQR.svg(texte, opts) -> string,
         PZQR.render(element) lit les attributs data-* et injecte le SVG.
*/
(function (root) {
  'use strict';

  /* ───────────────────── corps de Galois GF(256) ───────────────────── */
  /* Polynome primitif 0x11D, celui de la norme ISO/IEC 18004. */
  var EXP = new Uint8Array(512), LOG = new Uint8Array(256);
  (function () {
    var x = 1, i;
    for (i = 0; i < 255; i++) {
      EXP[i] = x; LOG[x] = i;
      x <<= 1;
      if (x & 0x100) x ^= 0x11d;
    }
    for (i = 255; i < 512; i++) EXP[i] = EXP[i - 255];
  })();

  function gmul(a, b) { return (a === 0 || b === 0) ? 0 : EXP[LOG[a] + LOG[b]]; }

  function polyMul(a, b) {
    var r = new Array(a.length + b.length - 1), i, j;
    for (i = 0; i < r.length; i++) r[i] = 0;
    for (i = 0; i < a.length; i++)
      for (j = 0; j < b.length; j++) r[i + j] ^= gmul(a[i], b[j]);
    return r;
  }

  /* Polynome generateur de Reed-Solomon : produit des (x - alpha^i). */
  var GEN_CACHE = {};
  function generator(n) {
    if (GEN_CACHE[n]) return GEN_CACHE[n];
    var g = [1];
    for (var i = 0; i < n; i++) g = polyMul(g, [1, EXP[i]]);
    GEN_CACHE[n] = g;
    return g;
  }

  function ecCodewords(data, ecLen) {
    var gen = generator(ecLen), res = new Array(ecLen), i, j;
    for (i = 0; i < ecLen; i++) res[i] = 0;
    for (i = 0; i < data.length; i++) {
      var factor = data[i] ^ res[0];
      res.shift(); res.push(0);
      for (j = 0; j < ecLen; j++) res[j] ^= gmul(gen[j + 1], factor);
    }
    return res;
  }

  /* ───────────────────── tables de la norme, niveau M ───────────────────── */
  /* [octets de correction par bloc, blocs groupe 1, donnees/bloc g1,
      blocs groupe 2, donnees/bloc g2] — versions 1 a 15. */
  var ECC_M = {
    1:  [10, 1, 16, 0, 0],
    2:  [16, 1, 28, 0, 0],
    3:  [26, 1, 44, 0, 0],
    4:  [18, 2, 32, 0, 0],
    5:  [24, 2, 43, 0, 0],
    6:  [16, 4, 27, 0, 0],
    7:  [18, 4, 31, 0, 0],
    8:  [22, 2, 38, 2, 39],
    9:  [22, 3, 36, 2, 37],
    10: [26, 4, 43, 1, 44],
    11: [30, 1, 50, 4, 51],
    12: [22, 6, 36, 2, 37],
    13: [22, 8, 37, 1, 38],
    14: [24, 4, 40, 5, 41],
    15: [24, 5, 41, 5, 42]
  };

  var ALIGN = {
    1: [], 2: [6, 18], 3: [6, 22], 4: [6, 26], 5: [6, 30], 6: [6, 34],
    7: [6, 22, 38], 8: [6, 24, 42], 9: [6, 26, 46], 10: [6, 28, 50],
    11: [6, 30, 54], 12: [6, 32, 58], 13: [6, 34, 62],
    14: [6, 26, 46, 66], 15: [6, 26, 48, 70]
  };

  function dataCapacity(v) {
    var e = ECC_M[v];
    return e[1] * e[2] + e[3] * e[4];
  }

  /* ───────────────────── encodage des donnees ───────────────────── */

  function utf8Bytes(str) {
    if (typeof TextEncoder !== 'undefined') return Array.prototype.slice.call(new TextEncoder().encode(str));
    var out = [], i, c;
    for (i = 0; i < str.length; i++) {
      c = str.charCodeAt(i);
      if (c < 0x80) out.push(c);
      else if (c < 0x800) out.push(0xc0 | (c >> 6), 0x80 | (c & 63));
      else out.push(0xe0 | (c >> 12), 0x80 | ((c >> 6) & 63), 0x80 | (c & 63));
    }
    return out;
  }

  function pickVersion(byteLen) {
    for (var v = 1; v <= 15; v++) {
      var cci = v < 10 ? 8 : 16;
      var need = Math.ceil((4 + cci + byteLen * 8) / 8);
      if (need <= dataCapacity(v)) return v;
    }
    throw new Error('charge utile trop longue pour un QR version 15');
  }

  function bitStream(bytes, version) {
    var bits = [], i, j;
    function push(val, len) {
      for (var k = len - 1; k >= 0; k--) bits.push((val >> k) & 1);
    }
    push(4, 4);                                   /* mode octet */
    push(bytes.length, version < 10 ? 8 : 16);    /* compteur de caracteres */
    for (i = 0; i < bytes.length; i++) push(bytes[i], 8);

    var cap = dataCapacity(version) * 8;
    for (i = 0; i < 4 && bits.length < cap; i++) bits.push(0);   /* terminateur */
    while (bits.length % 8 !== 0) bits.push(0);

    var out = [];
    for (i = 0; i < bits.length; i += 8) {
      var b = 0;
      for (j = 0; j < 8; j++) b = (b << 1) | bits[i + j];
      out.push(b);
    }
    var pad = [0xec, 0x11], p = 0;
    while (out.length < dataCapacity(version)) out.push(pad[p++ % 2]);
    return out;
  }

  /* Entrelacement des blocs de donnees puis des blocs de correction. */
  function interleave(data, version) {
    var e = ECC_M[version];
    var ecLen = e[0], blocks = [], ecBlocks = [], pos = 0, i, k;
    for (i = 0; i < e[1]; i++) { blocks.push(data.slice(pos, pos + e[2])); pos += e[2]; }
    for (i = 0; i < e[3]; i++) { blocks.push(data.slice(pos, pos + e[4])); pos += e[4]; }
    for (i = 0; i < blocks.length; i++) ecBlocks.push(ecCodewords(blocks[i], ecLen));

    var out = [], max = Math.max(e[2], e[4]);
    for (k = 0; k < max; k++)
      for (i = 0; i < blocks.length; i++)
        if (k < blocks[i].length) out.push(blocks[i][k]);
    for (k = 0; k < ecLen; k++)
      for (i = 0; i < ecBlocks.length; i++) out.push(ecBlocks[i][k]);
    return out;
  }

  /* ───────────────────── matrice ───────────────────── */

  function newMatrix(n) {
    var m = [], i, j;
    for (i = 0; i < n; i++) { m.push([]); for (j = 0; j < n; j++) m[i].push(null); }
    return m;
  }

  function placeFinder(m, r, c) {
    for (var i = -1; i <= 7; i++) {
      for (var j = -1; j <= 7; j++) {
        var rr = r + i, cc = c + j;
        if (rr < 0 || cc < 0 || rr >= m.length || cc >= m.length) continue;
        var inner = (i >= 0 && i <= 6 && (j === 0 || j === 6)) ||
                    (j >= 0 && j <= 6 && (i === 0 || i === 6)) ||
                    (i >= 2 && i <= 4 && j >= 2 && j <= 4);
        m[rr][cc] = inner ? 1 : 0;
      }
    }
  }

  function placeAlignment(m, version) {
    var pos = ALIGN[version], n = m.length, a, b, i, j;
    for (a = 0; a < pos.length; a++) {
      for (b = 0; b < pos.length; b++) {
        var r = pos[a], c = pos[b];
        /* Pas de motif d'alignement sur les trois motifs de reperage. */
        if ((r <= 8 && c <= 8) || (r <= 8 && c >= n - 9) || (r >= n - 9 && c <= 8)) continue;
        for (i = -2; i <= 2; i++)
          for (j = -2; j <= 2; j++)
            m[r + i][c + j] = (Math.abs(i) === 2 || Math.abs(j) === 2 || (i === 0 && j === 0)) ? 1 : 0;
      }
    }
  }

  function reserveFormat(m) {
    var n = m.length, i;
    for (i = 0; i <= 8; i++) {
      if (m[8][i] === null) m[8][i] = 0;
      if (m[i][8] === null) m[i][8] = 0;
    }
    for (i = 0; i < 8; i++) {
      if (m[8][n - 1 - i] === null) m[8][n - 1 - i] = 0;
      if (m[n - 1 - i][8] === null) m[n - 1 - i][8] = 0;
    }
    m[n - 8][8] = 1; /* module sombre, toujours allume */
  }

  function buildSkeleton(version) {
    var n = version * 4 + 17, m = newMatrix(n), i;
    placeFinder(m, 0, 0);
    placeFinder(m, 0, n - 7);
    placeFinder(m, n - 7, 0);
    placeAlignment(m, version);
    for (i = 8; i < n - 8; i++) {                 /* motifs de synchronisation */
      if (m[6][i] === null) m[6][i] = (i % 2 === 0) ? 1 : 0;
      if (m[i][6] === null) m[i][6] = (i % 2 === 0) ? 1 : 0;
    }
    reserveFormat(m);
    if (version >= 7) {                           /* zones d'information de version */
      for (i = 0; i < 6; i++) {
        for (var j = 0; j < 3; j++) {
          if (m[i][n - 11 + j] === null) m[i][n - 11 + j] = 0;
          if (m[n - 11 + j][i] === null) m[n - 11 + j][i] = 0;
        }
      }
    }
    return m;
  }

  function placeData(m, codewords) {
    var n = m.length, bitIdx = 0, up = true, col, row, c;
    function bit() {
      var byteI = bitIdx >> 3;
      if (byteI >= codewords.length) { bitIdx++; return 0; }
      var b = (codewords[byteI] >> (7 - (bitIdx & 7))) & 1;
      bitIdx++;
      return b;
    }
    for (col = n - 1; col > 0; col -= 2) {
      if (col === 6) col--;                        /* la colonne 6 est le timing */
      for (var k = 0; k < n; k++) {
        row = up ? (n - 1 - k) : k;
        for (c = 0; c < 2; c++) {
          var cc = col - c;
          if (m[row][cc] === null) m[row][cc] = bit();
        }
      }
      up = !up;
    }
  }

  var MASKS = [
    function (r, c) { return (r + c) % 2 === 0; },
    function (r)    { return r % 2 === 0; },
    function (r, c) { return c % 3 === 0; },
    function (r, c) { return (r + c) % 3 === 0; },
    function (r, c) { return (Math.floor(r / 2) + Math.floor(c / 3)) % 2 === 0; },
    function (r, c) { return ((r * c) % 2) + ((r * c) % 3) === 0; },
    function (r, c) { return (((r * c) % 2) + ((r * c) % 3)) % 2 === 0; },
    function (r, c) { return (((r + c) % 2) + ((r * c) % 3)) % 2 === 0; }
  ];

  /* La norme interdit de masquer les motifs fonctionnels : on retient donc une
     carte des modules reserves avant de poser les donnees. */
  function functionMap(version) {
    var skel = buildSkeleton(version), n = skel.length, map = [], i, j;
    for (i = 0; i < n; i++) { map.push([]); for (j = 0; j < n; j++) map[i].push(skel[i][j] !== null); }
    return map;
  }

  function penalty(m) {
    var n = m.length, score = 0, i, j, run, last, dark = 0;

    function lineScore(get) {
      var s = 0, r = 1, prev = get(0);
      for (var k = 1; k < n; k++) {
        var v = get(k);
        if (v === prev) { r++; }
        else { if (r >= 5) s += 3 + (r - 5); r = 1; prev = v; }
      }
      if (r >= 5) s += 3 + (r - 5);
      return s;
    }
    for (i = 0; i < n; i++) {
      score += lineScore((function (row) { return function (k) { return m[row][k]; }; })(i));
      score += lineScore((function (col) { return function (k) { return m[k][col]; }; })(i));
    }

    for (i = 0; i < n - 1; i++)
      for (j = 0; j < n - 1; j++) {
        var a = m[i][j];
        if (a === m[i][j + 1] && a === m[i + 1][j] && a === m[i + 1][j + 1]) score += 3;
      }

    var P1 = [1, 0, 1, 1, 1, 0, 1, 0, 0, 0, 0], P2 = [0, 0, 0, 0, 1, 0, 1, 1, 1, 0, 1];
    function findPat(get) {
      var s = 0;
      for (var k = 0; k + 11 <= n; k++) {
        var ok1 = true, ok2 = true;
        for (var t = 0; t < 11; t++) {
          if (get(k + t) !== P1[t]) ok1 = false;
          if (get(k + t) !== P2[t]) ok2 = false;
        }
        if (ok1) s += 40;
        if (ok2) s += 40;
      }
      return s;
    }
    for (i = 0; i < n; i++) {
      score += findPat((function (row) { return function (k) { return m[row][k]; }; })(i));
      score += findPat((function (col) { return function (k) { return m[k][col]; }; })(i));
    }

    for (i = 0; i < n; i++) for (j = 0; j < n; j++) if (m[i][j]) dark++;
    var pct = dark * 100 / (n * n);
    score += Math.floor(Math.abs(pct - 50) / 5) * 10;
    return score;
  }

  /* Information de format : 5 bits (niveau + masque), BCH(15,5), XOR 0x5412. */
  function formatBits(maskIdx) {
    var data = (0 << 3) | maskIdx;            /* niveau M = 00 */
    var v = data << 10;
    for (var i = 4; i >= 0; i--) if (v & (1 << (i + 10))) v ^= 0x537 << i;
    return ((data << 10) | v) ^ 0x5412;
  }

  function versionBits(version) {
    var v = version << 12;
    for (var i = 5; i >= 0; i--) if (v & (1 << (i + 12))) v ^= 0x1f25 << i;
    return (version << 12) | v;
  }

  /* Placement des 15 bits d'information de format, ISO/IEC 18004 §8.9.
     L'ordre compte : le bit 0 est le bit de poids faible et va en bas de la
     bande verticale, pas en haut de l'horizontale. Inverser les deux donne un
     mot que le contrôle BCH du lecteur rejette — le symbole est alors refusé
     bien que les données soient intactes. */
  function writeFormat(m, maskIdx) {
    var n = m.length, bits = formatBits(maskIdx), i, bit;
    for (i = 0; i < 15; i++) {
      bit = (bits >> i) & 1;
      /* copie 1 : colonne 8, de haut en bas, puis coin bas-gauche */
      if (i < 6)      m[i][8] = bit;
      else if (i < 8) m[i + 1][8] = bit;
      else            m[n - 15 + i][8] = bit;
      /* copie 2 : ligne 8, depuis la droite, puis coin haut-gauche */
      if (i < 8)      m[8][n - 1 - i] = bit;
      else if (i < 9) m[8][15 - i] = bit;
      else            m[8][14 - i] = bit;
    }
    m[n - 8][8] = 1;
  }

  function writeVersion(m, version) {
    if (version < 7) return;
    var n = m.length, bits = versionBits(version), i, j;
    for (i = 0; i < 18; i++) {
      var bit = (bits >> i) & 1, r = Math.floor(i / 3), c = i % 3;
      m[r][n - 11 + c] = bit;
      m[n - 11 + c][r] = bit;
    }
  }

  function encode(text) {
    var bytes = utf8Bytes(text);
    var version = pickVersion(bytes.length);
    var codewords = interleave(bitStream(bytes, version), version);
    var fmap = functionMap(version);

    var best = null, bestScore = Infinity;
    for (var mi = 0; mi < 8; mi++) {
      var m = buildSkeleton(version);
      placeData(m, codewords);
      for (var r = 0; r < m.length; r++)
        for (var c = 0; c < m.length; c++)
          if (!fmap[r][c] && MASKS[mi](r, c)) m[r][c] ^= 1;
      writeFormat(m, mi);
      writeVersion(m, version);
      var s = penalty(m);
      if (s < bestScore) { bestScore = s; best = m; }
    }
    return { matrix: best, version: version, size: best.length };
  }

  /* ───────────────────── charge utile Swiss QR Code v2.0 ───────────────────── */

  function amountString(cents) {
    var n = parseInt(cents, 10);
    if (!isFinite(n) || n <= 0) return '';
    var ct = n % 100;
    return Math.floor(n / 100) + '.' + (ct < 10 ? '0' + ct : String(ct));
  }

  function payload(o) {
    var lines = [
      'SPC', '0200', '1',
      String(o.iban || '').replace(/\s+/g, ''),
      'S',
      o.name || '', o.street || '', o.nr || '', o.zip || '', o.city || '', o.country || 'CH',
      '', '', '', '', '', '', '',                 /* beneficiaire final : vide */
      amountString(o.amountCents),
      o.currency || 'CHF',
      '', '', '', '', '', '', '',                 /* debiteur final : vide */
      'NON', '',                                  /* pas de reference structuree */
      String(o.reference || '').slice(0, 140),
      'EPD'
    ];
    return lines.join('\n');
  }

  /* ───────────────────── rendu SVG ───────────────────── */

  /* Geometrie de la croix suisse, espace local 0..19.8, centree sur (10,10),
     reprise telle quelle de l'implementation de reference. L'echelle vaut
     7 mm / 19 unites, et le code mesure 45.8 mm : la croix occupe donc
     7/45.8 de la largeur du QR. */
  var CROSS_RATIO = 7 / 45.8;

  function crossSvg(n) {
    var side = n * CROSS_RATIO;
    var s = side / 19;
    var off = n / 2 - 10 * s;
    var sq = 'M0.7,0.7 H19.1 V19.1 H0.7 Z';
    return '<g transform="translate(' + off.toFixed(4) + ',' + off.toFixed(4) + ') scale(' + s.toFixed(6) + ')">' +
             '<path d="' + sq + '" fill="#000" stroke="#fff" stroke-width="1.4357"/>' +
             '<rect x="8.3" y="4" width="3.3" height="11" fill="#fff"/>' +
             '<rect x="4.4" y="7.9" width="11" height="3.3" fill="#fff"/>' +
           '</g>';
  }

  function svg(text, opts) {
    opts = opts || {};
    var q = opts.quiet == null ? 4 : opts.quiet;
    var res = encode(text), m = res.matrix, n = res.size, total = n + q * 2;
    var d = '', r, c;
    for (r = 0; r < n; r++) {
      c = 0;
      while (c < n) {
        if (!m[r][c]) { c++; continue; }
        var start = c;
        while (c < n && m[r][c]) c++;
        d += 'M' + (start + q) + ',' + (r + q) + 'h' + (c - start) + 'v1h' + -(c - start) + 'z';
      }
    }
    var px = opts.size ? ' width="' + opts.size + '" height="' + opts.size + '"' : '';
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + total + ' ' + total + '"' + px +
           ' shape-rendering="crispEdges" role="img"' +
           (opts.label ? ' aria-label="' + String(opts.label).replace(/"/g, '&quot;') + '"' : ' aria-hidden="true"') + '>' +
           '<rect width="' + total + '" height="' + total + '" fill="#fff"/>' +
           '<path d="' + d + '" fill="#000"/>' +
           '<g transform="translate(' + q + ',' + q + ')">' + crossSvg(n) + '</g>' +
           '</svg>';
  }

  function render(el) {
    if (!el || el.getAttribute('data-pz-qr-done')) return;
    try {
      var text = payload({
        iban: el.getAttribute('data-iban'),
        name: el.getAttribute('data-name'),
        street: el.getAttribute('data-street'),
        nr: el.getAttribute('data-nr'),
        zip: el.getAttribute('data-zip'),
        city: el.getAttribute('data-city'),
        country: el.getAttribute('data-country') || 'CH',
        amountCents: el.getAttribute('data-amount-cents'),
        currency: el.getAttribute('data-currency') || 'CHF',
        reference: el.getAttribute('data-ref')
      });
      el.innerHTML = svg(text, { size: el.getAttribute('data-size') || null, label: el.getAttribute('data-label') || '' });
      el.setAttribute('data-pz-qr-done', '1');
    } catch (e) {
      /* Un QR absent vaut mieux qu'un QR faux : les coordonnees restent
         lisibles en texte juste au-dessus. */
      el.setAttribute('data-pz-qr-error', String(e && e.message || e));
    }
  }

  function renderAll(scope) {
    var list = (scope || document).querySelectorAll('[data-pz-qr]');
    Array.prototype.forEach.call(list, function (el) {
      /* Le portail rend vingt factures dans la page, une seule est visible :
         encoder les dix-neuf autres couterait du temps pour rien. */
      if (el.closest && el.closest('[hidden]')) return;
      render(el);
    });
  }

  root.PZQR = { payload: payload, svg: svg, encode: encode, render: render, renderAll: renderAll };

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { renderAll(); });
    else renderAll();
  }
})(typeof window !== 'undefined' ? window : this);
